export const provinceBbox = {
    "bc": [[-139.06, 48.30], [-114.03, 60.00]],
    "ab": [[-120.00, 48.99], [-109.99, 60.00]],
    "sk": [[-109.99, 48.99], [-101.36, 60.00]],
    "mb": [[-102.03, 48.99], [-88.94, 60.00]],
    "on": [[-95.16, 41.66], [-74.34, 56.86]],
    "qc": [[-79.76, 44.99], [-57.10, 62.59]],
    "ns": [[-66.32, 43.42], [-59.68, 47.03]],
    "pe": [[-64.41, 45.95], [-61.97, 47.06]],
    "nl": [[-67.80, 46.61], [-52.61, 60.37]],
    "yt": [[-141.00, 60.00], [-123.81, 69.65]],
    "nt": [[-136.44, 60.00], [-101.98, 78.76]],
    "nu": [[-120.68, 51.64], [-61.08, 83.11]],
    "us": [[-139.06, 41.50], [-52.61, 42.42]],
};